var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 6.50028H5.61484L9.06485 3.06528C9.3473 2.78282 9.50598 2.39973 9.50598 2.00028C9.50598 1.60083 9.3473 1.21773 9.06485 0.935277C8.78239 0.652822 8.3993 0.494141 7.99984 0.494141C7.60039 0.494141 7.2173 0.652822 6.93484 0.935277L0.934845 6.93528C0.798284 7.07793 0.691236 7.24615 0.619844 7.43028C0.469817 7.79547 0.469817 8.20508 0.619844 8.57028C0.691236 8.7544 0.798284 8.92262 0.934845 9.06528L6.93484 15.0653C7.07429 15.2059 7.24019 15.3175 7.42298 15.3936C7.60577 15.4698 7.80183 15.509 7.99984 15.509C8.19786 15.509 8.39392 15.4698 8.57671 15.3936C8.7595 15.3175 8.9254 15.2059 9.06485 15.0653C9.20544 14.9258 9.31703 14.7599 9.39318 14.5771C9.46933 14.3944 9.50854 14.1983 9.50854 14.0003C9.50854 13.8023 9.46933 13.6062 9.39318 13.4234C9.31703 13.2406 9.20544 13.0747 9.06485 12.9353L5.61484 9.50028H19.9998C20.3977 9.50028 20.7792 9.34224 21.0605 9.06094C21.3418 8.77963 21.4998 8.3981 21.4998 8.00028C21.4998 7.60245 21.3418 7.22092 21.0605 6.93962C20.7792 6.65831 20.3977 6.50028 19.9998 6.50028Z",
    fill: "#4B4B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.6d47f8e29ca6462e8f6ab3ef953bb7a5.svg";
export { ForwardRef as ReactComponent };